import React from 'react';
import { Box, Backdrop, Typography, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';

import FeedbackForm from './FeedbackForm';
import { useModalStyles } from '../../../auth/hooks/useModalStyles';
import { useFeedbackModal } from './context/context';

import { useStyles } from './styles';

const FeedbackModal = () => {
  const modalClasses = useModalStyles();
  const classes = useStyles();

  const { open, setOpen } = useFeedbackModal();

  return (
    <Modal sx={modalClasses.root} open={open} components={{ Backdrop }}>
      <Box
        component="div"
        sx={{ ...modalClasses.container, ...classes.container }}
      >
        <CloseIcon
          sx={modalClasses.closeIcon}
          onClick={() => {
            setOpen(false);
          }}
        />
        <Box component="div" sx={modalClasses.iconContainer}>
          <ThumbUpAltIcon />
        </Box>
        <Typography sx={modalClasses.title}>Feedback</Typography>
        <Box sx={{ ...modalClasses.content, ...classes.content }}>
          <FeedbackForm />
        </Box>
      </Box>
    </Modal>
  );
};

export default FeedbackModal;
